import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
// import {Familiar} from '../../../models/familiar';
import { Cliente } from '../../../models/cliente';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-bitacoraCliente-addedit',
  styles: [],
  templateUrl: 'bitacoraCliente-addedit.component.html',
  providers: [generalService]
})

export class BitacoraClienteAddEditComponent implements OnInit {
 
 @Input() bitacora:any;
  cliente:Cliente;
  bitacoraForm: FormGroup;
  titulo = "Agregar";
  list: any;


  constructor(
    private formBuilder: FormBuilder, 
    private _generalService: generalService, 
    public dialog: MatDialog, 
    public dataService: DataService, 
    private route: ActivatedRoute) 
  { 
    this.bitacora = new Object();
    this.cliente = new Cliente();
    this.list = new Object();  
  }

  ngOnInit() {
    this.buildForm();
    this.getInit(this.dataService.idCliente);

    if(this.dataService.isUpdate){
      this.titulo = "Editar";
      this.bitacora.TRANSACTION_ID = this.dataService.id;
      this.getBitacora(this.bitacora.TRANSACTION_ID);
    }
  }

  getInit(id:any){
    this._generalService.metodoCall(`bitacora/getInitCliente/${id}`).subscribe(
      result => {            
        let res = JSON.parse(result);        
        this.cliente.Nombre = res.Table[0].NAME;
       
        this.list.Type = res.Table1;
        // this.list.State = res.Table3;
        // this.list.City = res.Table4;
        },
      error => {
        console.log(<any>error);
      }
    );
  }

   // getBitacora(id:any){

   // }

  getBitacora(id:any){
      this._generalService.metodoCall(`bitacora/consultarBitacoraCliente/${id}`).subscribe(
        result => {
          let res = JSON.parse(result);// this.familiar = JSON.parse(result.replace("[", "").replace("]", ""));     
          this.bitacora = res[0];
           // let fechas = this.familiar.fecha.split("/");
          // this.familiar.fecha = new Date(fechas[2], fechas[1] - 1, fechas[0]);     
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  buildForm() {
    this.bitacoraForm = this.formBuilder.group({
      Nombre: [{disabled:true}],//this.formBuilder.control(null),
      TYPE: this.formBuilder.control(null),
      COMMENTS: this.formBuilder.control(null, [Validators.required, Validators.maxLength(1000)]),
    });
    this.bitacoraForm.get('Nombre').disable();
  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  createBitacora(){
    this._generalService.metodoCallParams(this.bitacora, "bitacora/agregarBitacoraCliente").subscribe(
          result => {
            this._generalService.toastCall(result.message);
          },
          error => {
            console.log(<any>error);
          }
      ); 
  }

  updateBitacora(){
    this._generalService.metodoCallParams(this.bitacora, "bitacora/actualizarBitacoraCliente").subscribe(
          result => {
            this._generalService.toastCall(result.message);
          },
          error => {
            console.log(<any>error);
          }
      ); 
  }

  onSubmit() {
    this.bitacora.CUSTOMER_ID = this.dataService.idCliente; 
    if(this.dataService.isUpdate)
      this.updateBitacora();
    else
      this.createBitacora();
    this.cerrarModal();
  }
}


// WEBPACK FOOTER //
// ./src/app/cliente/bitacora/agregar-editar/bitacoraCliente-addedit.component.ts